/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type FleetAuthenticateEvent,
    FleetAuthenticateEventFromJSON,
    FleetAuthenticateEventToJSON,
} from '../models/FleetAuthenticateEvent';
import {
    type FleetAuthenticateEventCreate,
    FleetAuthenticateEventCreateFromJSON,
    FleetAuthenticateEventCreateToJSON,
} from '../models/FleetAuthenticateEventCreate';
import {
    type FleetAuthenticatePeriod,
    FleetAuthenticatePeriodFromJSON,
    FleetAuthenticatePeriodToJSON,
} from '../models/FleetAuthenticatePeriod';
import {
    type FleetAuthenticatePeriodSortKey,
    FleetAuthenticatePeriodSortKeyFromJSON,
    FleetAuthenticatePeriodSortKeyToJSON,
} from '../models/FleetAuthenticatePeriodSortKey';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type VehicleMovementPeriodSortKey,
    VehicleMovementPeriodSortKeyFromJSON,
    VehicleMovementPeriodSortKeyToJSON,
} from '../models/VehicleMovementPeriodSortKey';

export interface FleetAuthenticateEventsCreateFleetAuthenticateEventRequest {
    fleetAuthenticateEventCreate: FleetAuthenticateEventCreate;
}

export interface FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest {
    timezone: string;
    exportType: FleetAuthenticateEventsExportFleetAuthenticatePeriodsExportType;
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: FleetAuthenticatePeriodSortKey;
}

export interface FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: FleetAuthenticatePeriodSortKey;
}

export interface FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
}

export interface VehicleMovementsExportVehicleMovementPeriodsRequest {
    timezone: string;
    exportType: VehicleMovementsExportVehicleMovementPeriodsExportType;
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    vehicleIds?: Array<string> | null;
    userIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleMovementPeriodSortKey;
}

/**
 * FleetAuthenticateEventsApi - interface
 * 
 * @export
 * @interface FleetAuthenticateEventsApiInterface
 */
export interface FleetAuthenticateEventsApiInterface {
    /**
     * Creates request options for fleetAuthenticateEventsCreateFleetAuthenticateEvent without sending the request
     * @param {FleetAuthenticateEventCreate} fleetAuthenticateEventCreate 
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsCreateFleetAuthenticateEventRequestOpts(requestParameters: FleetAuthenticateEventsCreateFleetAuthenticateEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new fleet authenticate event
     * @summary Create a fleet authenticate event
     * @param {FleetAuthenticateEventCreate} fleetAuthenticateEventCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsCreateFleetAuthenticateEventRaw(requestParameters: FleetAuthenticateEventsCreateFleetAuthenticateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FleetAuthenticateEvent>>;

    /**
     * Create a new fleet authenticate event
     * Create a fleet authenticate event
     */
    fleetAuthenticateEventsCreateFleetAuthenticateEvent(requestParameters: FleetAuthenticateEventsCreateFleetAuthenticateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FleetAuthenticateEvent>;

    /**
     * Creates request options for fleetAuthenticateEventsExportFleetAuthenticatePeriods without sending the request
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {FleetAuthenticatePeriodSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsExportFleetAuthenticatePeriodsRequestOpts(requestParameters: FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest): Promise<runtime.RequestOpts>;

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * @summary Export fleet authenticate periods as login reports
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {FleetAuthenticatePeriodSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsExportFleetAuthenticatePeriodsRaw(requestParameters: FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * Export fleet authenticate periods as login reports
     */
    fleetAuthenticateEventsExportFleetAuthenticatePeriods(requestParameters: FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for fleetAuthenticateEventsListFleetAuthenticatePeriods without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {FleetAuthenticatePeriodSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsListFleetAuthenticatePeriodsRequestOpts(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the fleet authenticate periods with both a login and logout event.
     * @summary List completed fleet authenticate periods
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {FleetAuthenticatePeriodSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsListFleetAuthenticatePeriodsRaw(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FleetAuthenticatePeriod>>>;

    /**
     * Lists all the fleet authenticate periods with both a login and logout event.
     * List completed fleet authenticate periods
     */
    fleetAuthenticateEventsListFleetAuthenticatePeriods(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FleetAuthenticatePeriod>>;

    /**
     * Creates request options for fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequestOpts(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available
     * @summary List completed fleet authenticate periods metadata
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRaw(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available
     * List completed fleet authenticate periods metadata
     */
    fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for vehicleMovementsExportVehicleMovementPeriods without sending the request
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleMovementPeriodSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    vehicleMovementsExportVehicleMovementPeriodsRequestOpts(requestParameters: VehicleMovementsExportVehicleMovementPeriodsRequest): Promise<runtime.RequestOpts>;

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * @summary Export fleet authenticate periods as login reports
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleMovementPeriodSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetAuthenticateEventsApiInterface
     */
    vehicleMovementsExportVehicleMovementPeriodsRaw(requestParameters: VehicleMovementsExportVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * Export fleet authenticate periods as login reports
     */
    vehicleMovementsExportVehicleMovementPeriods(requestParameters: VehicleMovementsExportVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

}

/**
 * 
 */
export class FleetAuthenticateEventsApi extends runtime.BaseAPI implements FleetAuthenticateEventsApiInterface {

    /**
     * Creates request options for fleetAuthenticateEventsCreateFleetAuthenticateEvent without sending the request
     */
    async fleetAuthenticateEventsCreateFleetAuthenticateEventRequestOpts(requestParameters: FleetAuthenticateEventsCreateFleetAuthenticateEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['fleetAuthenticateEventCreate'] == null) {
            throw new runtime.RequiredError(
                'fleetAuthenticateEventCreate',
                'Required parameter "fleetAuthenticateEventCreate" was null or undefined when calling fleetAuthenticateEventsCreateFleetAuthenticateEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fleet_authenticate_events/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FleetAuthenticateEventCreateToJSON(requestParameters['fleetAuthenticateEventCreate']),
        };
    }

    /**
     * Create a new fleet authenticate event
     * Create a fleet authenticate event
     */
    async fleetAuthenticateEventsCreateFleetAuthenticateEventRaw(requestParameters: FleetAuthenticateEventsCreateFleetAuthenticateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FleetAuthenticateEvent>> {
        const requestOptions = await this.fleetAuthenticateEventsCreateFleetAuthenticateEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FleetAuthenticateEventFromJSON(jsonValue));
    }

    /**
     * Create a new fleet authenticate event
     * Create a fleet authenticate event
     */
    async fleetAuthenticateEventsCreateFleetAuthenticateEvent(requestParameters: FleetAuthenticateEventsCreateFleetAuthenticateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FleetAuthenticateEvent> {
        const response = await this.fleetAuthenticateEventsCreateFleetAuthenticateEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fleetAuthenticateEventsExportFleetAuthenticatePeriods without sending the request
     */
    async fleetAuthenticateEventsExportFleetAuthenticatePeriodsRequestOpts(requestParameters: FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['timezone'] == null) {
            throw new runtime.RequiredError(
                'timezone',
                'Required parameter "timezone" was null or undefined when calling fleetAuthenticateEventsExportFleetAuthenticatePeriods().'
            );
        }

        if (requestParameters['exportType'] == null) {
            throw new runtime.RequiredError(
                'exportType',
                'Required parameter "exportType" was null or undefined when calling fleetAuthenticateEventsExportFleetAuthenticatePeriods().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling fleetAuthenticateEventsExportFleetAuthenticatePeriods().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['exportType'] != null) {
            queryParameters['export_type'] = requestParameters['exportType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fleet_authenticate_events/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * Export fleet authenticate periods as login reports
     */
    async fleetAuthenticateEventsExportFleetAuthenticatePeriodsRaw(requestParameters: FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.fleetAuthenticateEventsExportFleetAuthenticatePeriodsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * Export fleet authenticate periods as login reports
     */
    async fleetAuthenticateEventsExportFleetAuthenticatePeriods(requestParameters: FleetAuthenticateEventsExportFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.fleetAuthenticateEventsExportFleetAuthenticatePeriodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fleetAuthenticateEventsListFleetAuthenticatePeriods without sending the request
     */
    async fleetAuthenticateEventsListFleetAuthenticatePeriodsRequestOpts(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling fleetAuthenticateEventsListFleetAuthenticatePeriods().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fleet_authenticate_events/periods`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the fleet authenticate periods with both a login and logout event.
     * List completed fleet authenticate periods
     */
    async fleetAuthenticateEventsListFleetAuthenticatePeriodsRaw(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FleetAuthenticatePeriod>>> {
        const requestOptions = await this.fleetAuthenticateEventsListFleetAuthenticatePeriodsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FleetAuthenticatePeriodFromJSON));
    }

    /**
     * Lists all the fleet authenticate periods with both a login and logout event.
     * List completed fleet authenticate periods
     */
    async fleetAuthenticateEventsListFleetAuthenticatePeriods(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FleetAuthenticatePeriod>> {
        const response = await this.fleetAuthenticateEventsListFleetAuthenticatePeriodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata without sending the request
     */
    async fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequestOpts(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fleet_authenticate_events/periods/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available
     * List completed fleet authenticate periods metadata
     */
    async fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRaw(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available
     * List completed fleet authenticate periods metadata
     */
    async fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata(requestParameters: FleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleMovementsExportVehicleMovementPeriods without sending the request
     */
    async vehicleMovementsExportVehicleMovementPeriodsRequestOpts(requestParameters: VehicleMovementsExportVehicleMovementPeriodsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['timezone'] == null) {
            throw new runtime.RequiredError(
                'timezone',
                'Required parameter "timezone" was null or undefined when calling vehicleMovementsExportVehicleMovementPeriods().'
            );
        }

        if (requestParameters['exportType'] == null) {
            throw new runtime.RequiredError(
                'exportType',
                'Required parameter "exportType" was null or undefined when calling vehicleMovementsExportVehicleMovementPeriods().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleMovementsExportVehicleMovementPeriods().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['exportType'] != null) {
            queryParameters['export_type'] = requestParameters['exportType'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_movements/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * Export fleet authenticate periods as login reports
     */
    async vehicleMovementsExportVehicleMovementPeriodsRaw(requestParameters: VehicleMovementsExportVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.vehicleMovementsExportVehicleMovementPeriodsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all fleet authenticate periods with respect to given filters.
     * Export fleet authenticate periods as login reports
     */
    async vehicleMovementsExportVehicleMovementPeriods(requestParameters: VehicleMovementsExportVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.vehicleMovementsExportVehicleMovementPeriodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum FleetAuthenticateEventsExportFleetAuthenticatePeriodsExportType {
    CSV = 'csv',
    XLSX = 'xlsx'
}
/**
  * @export
  * @enum {string}
  */
export enum VehicleMovementsExportVehicleMovementPeriodsExportType {
    CSV = 'csv',
    XLSX = 'xlsx'
}
